var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice"},[_c('p',[_vm._v("\n    The alerts web service displays NWS watches, warnings, advisories, and similar products.\n    Click the main menu down-arrow for a quick guide and documentation.\n  ")])])
}]

export { render, staticRenderFns }